import Service from '@/helpers/service'

export default {

    getTopTenSales(params) {
        return Service().get('sales-dashboard/get-top-ten-sales', {params});
    },
}